import { Grid, Slider } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';
import { useEffect, useState } from 'react';

import Text from '../react-components/Text';

const STEPS = 8;

interface RoundingMinutesSliderProps {
  defaultBounds?: number[];
  roundingMinutes: number;
  onChange: (value: number[]) => void;
}

export const RoundingMinutesSlider = ({ defaultBounds, roundingMinutes, onChange }: RoundingMinutesSliderProps) => {
  const [bounds, setBounds] = useState<number[]>([-roundingMinutes, roundingMinutes]);

  useEffect(() => {
    if (defaultBounds) {
      setBounds(defaultBounds);
    }
  }, [defaultBounds]);

  const getSliderMarks = () =>
    [
      -(roundingMinutes * 4),
      -(roundingMinutes * 3),
      -(roundingMinutes * 2),
      -(roundingMinutes * 1),
      0,
      roundingMinutes * 1,
      roundingMinutes * 2,
      roundingMinutes * 3,
      roundingMinutes * 4,
    ].map((number: number) => {
      return {
        value: number,
        label: `${number}`,
      };
    });

  const validBounds = (newBounds: number[]) => {
    if (newBounds[0] > 0 || newBounds[1] < 0) {
      return false;
    }
    return true;
  };

  return (
    <Grid container direction="column" wrap="nowrap">
      <Grid item>
        <Slider
          aria-labelledby="track-inverted-range-slider"
          getAriaValueText={(value: number) => `${value} min`}
          defaultValue={defaultBounds}
          min={(-roundingMinutes * STEPS) / 2}
          max={(roundingMinutes * STEPS) / 2}
          marks={getSliderMarks()}
          valueLabelDisplay="off"
          value={bounds}
          onChange={(event: any, value: number | number[]) => {
            if (validBounds(value as number[])) {
              setBounds(value as number[]);
            }
          }}
          onChangeCommitted={(event: any, value: number | number[]) => {
            if (validBounds(value as number[])) {
              onChange(value as number[]);
            }
          }}
          step={null}
          sx={{
            '& .MuiSlider-markLabel': {
              display: `none`,
            },
            '& .MuiSlider-mark': {
              display: `none`,
            },
            [`& .MuiSlider-mark[data-index="${STEPS / 2}"]`]: {
              display: `block`,
              backgroundColor: RoutalPalette.secondary40,
              height: `10px`,
              width: `4px`,
            },
          }}
          componentsProps={{
            root: {
              style: {
                marginBottom: `0px`,
              },
            },
          }}
        />
      </Grid>

      <Grid item container direction="row" justifyContent="space-around">
        <Grid item>
          <Text isBold style={{ fontSize: `12px` }} variant="button">{`${bounds[0]} min`}</Text>
        </Grid>

        <Grid item>
          <Text isBold style={{ fontSize: `12px` }} variant="button">{`${bounds[1]} min`}</Text>
        </Grid>
      </Grid>
    </Grid>
  );
};
